import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class WhatsappFlowService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.WHATSAPP_FLOW = "/api/whatsapp-flow";

        this.GET_BY_ID = '/{id}';
        this.GET_BY_PHONE_NUMBER_ID_AND_LEADS_CONNECTION = "/phone-number/{phoneNumberId}/leads/{leadsConnectionId}";
        this.GET_BY_PHONE_NUMBER_ID_AND_PROJECT_ID = "/phone-number/{phoneNumberId}/project/{projectId}";
        this.ACTIVE_FLOW = '/active-whatsapp-flow';
        this.DISABLE_ALL_FLOWS = '/disable-all-flows';
    }

    async getByLeadsConnectionIdAndPhoneNumberId(leadsConnectionId, phoneNumberId) {
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW + this.GET_BY_PHONE_NUMBER_ID_AND_LEADS_CONNECTION;
            url = url
                .replace('{phoneNumberId}', phoneNumberId)
                .replace('{leadsConnectionId}', leadsConnectionId);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async getByPhoneNumberIdAndProjectId(phoneNumberId, projectId) {
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW + this.GET_BY_PHONE_NUMBER_ID_AND_PROJECT_ID;
            url = url
                .replace('{phoneNumberId}', phoneNumberId)
                .replace('{projectId}', projectId);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async createWhatsappFlow(whatsappFlowStr){
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const createdWhatsappBot = this.fetch(url,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(whatsappFlowStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return createdWhatsappBot;
        }
        catch(err){
            console.log(err);
        }
    };

    async updateWhatsappFlow(whatsappFlowStr){
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const updatedWhatsappBot = this.fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(whatsappFlowStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return updatedWhatsappBot;
        }
        catch(err){
            console.log(err);
        }
    }
    
    async activeWhatsappFlow(whatsappFlowStr){
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW + this.ACTIVE_FLOW;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const updatedWhatsappBot = this.fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(whatsappFlowStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return updatedWhatsappBot;
        }
        catch(err){
            console.log(err);
        }
    }    
    
    async disableAllWhatsappFlow(whatsappFlowStr){
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW + this.DISABLE_ALL_FLOWS;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const updatedWhatsappBot = this.fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(whatsappFlowStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return updatedWhatsappBot;
        }
        catch(err){
            console.log(err);
        }
    }    
    
    async deleteWhatsappFlow(whatsappFlowStr){
        try {
            let url = window.location.origin + this.WHATSAPP_FLOW;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const updatedWhatsappBot = this.fetch(url,{
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(whatsappFlowStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return updatedWhatsappBot;
        }
        catch(err){
            console.log(err);
        }
    }
}

export default WhatsappFlowService;
